import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": "450"
    },
    model: {
      value: _vm.IsTokenExpired,
      callback: function callback($$v) {
        _vm.IsTokenExpired = $$v;
      },
      expression: "IsTokenExpired"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v("Session Expired")]), _c(VCardText, [_vm._v("Your session has expired. Please login again.")]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.agreeDialog
    }
  }, [_vm._v("Login")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };